import { render, staticRenderFns } from "./UtilTable.vue?vue&type=template&id=6295eab8&scoped=true"
import script from "./UtilTable.vue?vue&type=script&lang=js"
export * from "./UtilTable.vue?vue&type=script&lang=js"
import style0 from "./UtilTable.vue?vue&type=style&index=0&id=6295eab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6295eab8",
  null
  
)

export default component.exports